function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M26 13c.6-.5.6-1.5 0-2l-9.5-9.6a1.5 1.5 0 10-2.1 2.1l8.5 8.5-8.5 8.5a1.5 1.5 0 102.1 2.1l9.6-9.5zm-26 .5h25v-3H0v3z"
});

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNyAyNCI+CiAgPHBhdGggZD0iTTI2IDEzYy42LS41LjYtMS41IDAtMmwtOS41LTkuNmExLjUgMS41IDAgMTAtMi4xIDIuMWw4LjUgOC41LTguNSA4LjVhMS41IDEuNSAwIDEwMi4xIDIuMWw5LjYtOS41em0tMjYgLjVoMjV2LTNIMHYzeiIvPgo8L3N2Zz4=";
export { SvgArrow as ReactComponent };